import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { testimonials } from '@/mocks/articles';

const faqs = [
  {
    question: '黑料入口是什么？',
    answer: '黑料入口是一个专注于娱乐资讯聚合的平台，每日更新最新的明星八卦、影视吃瓜、网红爆料等内容。我们致力于为用户提供最新、最全、最可靠的娱乐资讯服务。无论是51吃瓜黑料入口一二三还是黑料网在线观看，都可以通过黑料入口一站式获取。',
  },
  {
    question: '如何下载黑料入口APP？',
    answer: '您可以在苹果App Store或各大安卓应用商店搜索"黑料入口"进行下载。也可以在黑料入口官网直接扫描首页的二维码进行下载。黑料入口下载完全免费，注册后即可享受全部功能。',
  },
  {
    question: '黑料入口的内容多久更新一次？',
    answer: '黑料入口的内容全天候实时更新。我们的编辑团队7×24小时追踪娱乐热点，确保您第一时间获取最新的吃瓜内容。同时，黑料网在线观看和吃瓜黑料在线等功能也保持同步更新。',
  },
  {
    question: '黑料入口的内容是否可靠？',
    answer: '我们严格遵守新闻伦理和行业规范，所有内容均经过编辑团队核实后发布。对于未经证实的传闻，我们会明确标注"传闻"或"待证实"，确保您获取的信息透明可靠。',
  },
  {
    question: '如何在黑料入口上搜索特定内容？',
    answer: '您可以在黑料入口首页顶部的搜索框输入关键词进行搜索。系统会根据您的搜索词智能匹配相关的文章和话题。支持搜索明星名字、事件关键词、话题标签等多种方式。',
  },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 黑料入口 | 品牌介绍与联系方式';
  }, []);

  return (
    <>
      <header>
        <Navbar />
      </header>

      <main className="pt-24 pb-16 bg-background-50">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://heiliaorukou.com/' },
                { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://heiliaorukou.com/about' },
              ],
            }),
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              })),
            }),
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              name: '关于我们 - 黑料入口',
              description: '黑料入口品牌介绍、口碑评价与联系方式。了解51吃瓜黑料入口一二三、黑料入口官网及黑料入口下载相关信息。',
              url: 'https://heiliaorukou.com/about',
              isPartOf: {
                '@type': 'WebSite',
                name: '黑料入口',
                url: 'https://heiliaorukou.com/',
              },
            }),
          }}
        />

        <div className="mx-auto px-4 md:px-6 max-w-[1440px]">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-10">
            <a href="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">首页</a>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800">关于我们</span>
          </nav>

          <section className="mb-16 md:mb-24">
            <div className="max-w-3xl">
              <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300/40 text-xs font-medium text-foreground-600 whitespace-nowrap mb-4">
                品牌介绍
              </span>
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-6">
                关于黑料入口
              </h1>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                黑料入口是国内领先的娱乐资讯聚合平台，致力于为用户提供最新、最全、最可靠的吃瓜内容服务。我们的团队由资深娱乐记者、内容编辑和技术工程师组成，全天候追踪娱乐圈的每一个热点动态。
              </p>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                自平台上线以来，黑料入口已累计服务超过千万用户，成为众多吃瓜群众每日必刷的资讯平台。无论是51吃瓜黑料入口一二三、黑料入口官网，还是黑料入口下载，我们都以用户需求为核心，持续优化产品体验。
              </p>
              <p className="text-base text-foreground-700 leading-relaxed">
                我们坚持<strong>真实、快速、全面</strong>的内容准则，在信息爆炸的时代为用户筛选最有价值的娱乐资讯。黑料入口不仅是你的吃瓜助手，更是连接娱乐世界的窗口。
              </p>
            </div>
          </section>

          <section className="mb-16 md:mb-24">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">口碑评价</h2>
            <p className="text-sm text-foreground-500 mb-8">来自行业和用户对我们的真实评价</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div key={t.id} className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                  <div className="text-4xl text-foreground-300 mb-3">&ldquo;</div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-5">{t.quote}</p>
                  <div className="border-t border-background-200/70 pt-4">
                    <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16 md:mb-24">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">联系我们</h2>
            <p className="text-sm text-foreground-500 mb-8">如有商务合作、内容建议或问题反馈，欢迎通过以下方式联系我们</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="font-bold text-foreground-950 mb-2">商务合作</h3>
                <p className="text-sm text-foreground-500 mb-2">广告投放、品牌合作</p>
                <a href="mailto:business@heiliaorukou.com" className="text-sm text-primary-500 hover:text-primary-600 transition-colors">business@heiliaorukou.com</a>
              </div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                  <i className="ri-edit-line text-xl text-accent-500"></i>
                </div>
                <h3 className="font-bold text-foreground-950 mb-2">内容投稿</h3>
                <p className="text-sm text-foreground-500 mb-2">爆料投稿、内容建议</p>
                <a href="mailto:content@heiliaorukou.com" className="text-sm text-primary-500 hover:text-primary-600 transition-colors">content@heiliaorukou.com</a>
              </div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mb-4">
                  <i className="ri-question-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="font-bold text-foreground-950 mb-2">客服支持</h3>
                <p className="text-sm text-foreground-500 mb-2">使用问题、技术支持</p>
                <a href="mailto:support@heiliaorukou.com" className="text-sm text-primary-500 hover:text-primary-600 transition-colors">support@heiliaorukou.com</a>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">常见问题</h2>
            <div className="space-y-3 max-w-3xl">
              {faqs.map((faq, idx) => (
                <details key={idx} className="group bg-background-100 rounded-lg border border-background-200/70">
                  <summary className="flex items-center justify-between px-6 py-4 cursor-pointer text-sm font-medium text-foreground-900 list-none">
                    {faq.question}
                    <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                  </summary>
                  <div className="px-6 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}